import _ from 'lodash';
import React from 'react';
import { observer } from 'mobx-react';
import createPermissionFeatureWithoutStoreHook from '../../hooks/CreatePermissionFeatureWithoutStoreHook';
export default function createPermissionFeatureComponent() {
    return function (permissionEnum, useDataAccessStoreHook) {
        var usePermissionFeatureWithoutStoreHook = createPermissionFeatureWithoutStoreHook()(permissionEnum);
        var permissionFeatureWithoutStoreComponent = function (_a) {
            var _b;
            var id = _a.id, children = _a.children, requiredPermission = _a.requiredPermission, requiredPermissions = _a.requiredPermissions, subLevel = _a.subLevel;
            var _c = usePermissionFeatureWithoutStoreHook(), hasPermission = _c.hasPermission, hasPermissions = _c.hasPermissions, hasPermissionOnSubLevel = _c.hasPermissionOnSubLevel;
            var dataAccessStore = useDataAccessStoreHook();
            var activeId = id || ((_b = dataAccessStore.activeItem) === null || _b === void 0 ? void 0 : _b.id);
            if (!activeId) {
                return null;
            }
            if (requiredPermission) {
                var _hasPermission = subLevel ?
                    hasPermissionOnSubLevel(subLevel, activeId, requiredPermission) :
                    hasPermission(activeId, requiredPermission);
                if (!_hasPermission) {
                    return null;
                }
                if (_.isArray(children)) {
                    return (React.createElement(React.Fragment, null, children));
                }
                return children;
            }
            if (requiredPermissions && hasPermissions(activeId, requiredPermissions)) {
                if (_.isArray(children)) {
                    return (React.createElement(React.Fragment, null, children));
                }
                return children;
            }
            return null;
        };
        return observer(permissionFeatureWithoutStoreComponent);
    };
}
//# sourceMappingURL=PermissionFeatureComponentCreator.js.map